var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.00257 9.8906C9.3735 9.3342 9.99796 9 10.6667 9H24.5963C25.7009 9 26.5963 9.89543 26.5963 11V22C26.5963 23.1046 25.7009 24 24.5963 24H10.6667C9.99796 24 9.3735 23.6658 9.00257 23.1094L5.3359 17.6094C4.88803 16.9376 4.88803 16.0624 5.3359 15.3906L9.00257 9.8906ZM18.2522 16.5055L19.8451 14.9161C20.0442 14.6954 20.0553 14.3642 19.8451 14.1545C19.635 13.9448 19.292 13.9448 19.0819 14.1545L17.5 15.7439L15.9071 14.1545C15.708 13.9559 15.354 13.9338 15.1549 14.1545C14.9558 14.3753 14.9558 14.7174 15.1549 14.9161L16.7367 16.5055L15.1438 18.0949C14.9336 18.3046 14.9336 18.6578 15.1438 18.8565C15.354 19.0552 15.6969 19.0552 15.896 18.8565L17.4889 17.2671L19.0819 18.8565C19.292 19.0662 19.635 19.0662 19.8451 18.8565C20.0553 18.6468 20.0553 18.3046 19.8451 18.0949L18.2522 16.5055Z",
    clipRule: "evenodd"
  })));
};
export default SvgDelete;